export default {
      id: "lft-light-usage",
      viewBox: "0 0 171 24",
      url: __webpack_public_path__ + "sprite.svg#lft-light-usage",
      toString: function () {
        return this.url;
      }
    }